import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { remove } from 'lodash';
import { IDiagnosticPoint } from '../../../../shared/models/diagnostic-points.model';

@Component({
  selector: 'app-wd-diagnostics-points-select',
  templateUrl: './wd-diagnostics-points-select.component.html',
  styleUrls: ['./wd-diagnostics-points-select.component.scss']
})
export class WdDiagnosticsPointsSelectComponent implements OnInit {
  listItems: IDiagnosticPoint[] = [];
  listSelectedItems: {id: any; text: string}[] = [];

  @Input()
  set items(value: IDiagnosticPoint[]) {
    this.listItems = value;
  }

  @Input()
  set selectedItems(value: IDiagnosticPoint[]) {
    this.listSelectedItems = value.map(item => {
      return {
        id: item.id,
        text: item.name
      }
    });
  }

  @Output()
  onSelectedItemsChange: EventEmitter<string[]> = new EventEmitter();
  @Output()
  selectItem: EventEmitter<number> = new EventEmitter();
  @Output()
  removeItem: EventEmitter<number> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onSelectItem(e: any) {
    const change = {id: e.id, text: e.text};
    this.listSelectedItems.push(change);

    this.selectItem.emit(e.id);
  }

  onRemoveItem(e: any, all: boolean) {
    if (all) {
      this.listSelectedItems = [];
    } else {
      remove(this.listSelectedItems, { id: e.id });
      this.listSelectedItems = this.listSelectedItems.slice();

      this.removeItem.emit(e.id);
    }
  }

}
